<template>
  <div class="Ssheader">
    <nav class="navbar container is-fluid">
      <div class="navbar-brand">
        <a class="navbar-item" href="/">
          <img src="/static/sarikayaSahinLogo.png" alt="Sarıkayaşahin Hukuk">
        </a>
      </div>
      <div class="navbar-menu navk" :class="{ navMenu: navMenu }">

        <router-link :class="{ active: menu.isActive }" v-for="(menu, index) in menuData" :key="`${index}`" :to="`/${menu.path}`" class="navbar-item " @click.native="navMenu = !navMenu">{{menu.name}}</router-link>

      </div>
      <div class="navbar-burger" @click="navMenu = !navMenu">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </nav>
  </div>
</template>

<script>
import swiperx from "./swiperx.vue";

export default {
  components: {
    swiperx
  },
  name: 'header',
  data() {
    return {
      msg: 'SarıkayaŞahin Web Development by Kaan KÜÇÜK',
      menuData: [
        { name: 'Home', path: '', isActive: false, a: 'activate' },
        { name: 'about us', path: 'about-us', isActive: false },
        { name: 'PRACTICE AREAS', path: 'practice-areas', isActive: false },
        { name: 'OUR TEAM', path: 'our-team', isActive: false },
        { name: 'PUBLICATIONS', path: 'publications', isActive: false },
        { name: 'CONTACT', path: 'contact', isActive: false },
        { name: 'TR', path: 'tr', isActive: false },
        { name: 'EN', path: '', isActive: false },
      ],
      navMenu: false
    }
  },
  methods: {
    activate: function() {
      this.navMenu = !navMenu;
      console.log(this.navMenu)
    }
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// header.vue?72b4fd98